export const LOAD_FOLDER_OFFERS_STARTED = "LOAD_FOLDER_OFFERS_STARTED";
export const LOAD_FOLDER_OFFERS_SUCCEEDED = "LOAD_FOLDER_OFFERS_SUCCEEDED";
export const LOAD_FOLDER_OFFERS_FAILED = "LOAD_FOLDER_OFFERS_FAILED";
